module.exports = __webpack_public_path__ + "static/media/state2024.6599f605.jpeg";